const Loader = "../assets/images/loader.gif";
const Logo = "../assets/images/databis_logo.png";
const Tick = "../assets/images/Tick.svg";
const Avtar = "../assets/images/avtar.png";
const Notification = "../assets/images/notification.svg";

const SliderImage1 = "../assets/images/login_slider_1.png";
const SliderImage2 = "../assets/images/login_slider_2.png";
const SliderImage3 = "../assets/images/login_slider_3.png";
// const SliderImage4 = "../assets/images/slider-4.png";
const Analytics = "../assets/images/analytics.svg";
const Batch = "../assets/images/batches.svg";
const Strains = "../assets/images/strains.svg";
const Employee = "../assets/images/employee.svg";
const Reward = "../assets/images/reward.svg";

const Api = "../assets/images/api.svg";

const Qr = "../assets/images/qr.svg";
const Announcements = "../assets/images/announcements.svg";
const MenuUser = "../assets/images/menuuser.svg";
const Logout = "../assets/images/logout.svg";
const Company = "../assets/images/comapny.svg";

const profilePlaceholder = "../assets/images/profile-placeholder.png";
const editIcon = "../assets/images/edit-icon.svg";
const whiteEditIcon = "../assets/images/white-edit-icon.svg";
const walletImage = "../assets/images/wallet-image.svg";
export const AddCircle = "../assets/images/addcircle.svg";
export const infoIcon = "../assets/images/info-icon.svg";
export const cancelIcon = "../assets/images/cancel-icon.svg";
const Support = "../assets/images/support.svg";
export const deleteIcon = "../assets/images/delete-icon.svg";

const FilterIcon = "../assets/images/filter.svg";
const FilterAccordion = "../assets/images/filteraccordian.svg";
const FilterDate = "../assets/images/date.svg";

const TableAction = "../assets/images/tableaction.svg";
const AddIcon = "../assets/images/add.svg";
const Verification = "../assets/images/verification.svg";
const AccessDenied = "../assets/images/access-denied.svg";
const ConnectionLost = "../assets/images/connectionLost.png";
const Importicon = "../assets/images/Import.svg";
const Uploadicon = "../assets/images/Upload.svg";
const Refreshicon = "../assets/images/refresh.svg";
const Refresh = "../assets/images/refresh.svg";
const NoDataIcon = "../assets/images/no-data.svg";
const CloudIcon = "../assets/images/Cloud.svg";
const PreviewImage = "../assets/images/preview.png";
const ExcelIcon = "../assets/images/Excel.svg";
const COAPassedIcon = "../assets/images/coa-passed.svg";
const COAFailedIcon = "../assets/images/coa-failed.svg";
const iconCalendar = "../assets/images/calendar-icon.svg";
const NoData = "../assets/images/No-faq.svg";
const upload = "../assets/images/cloud.svg";
const dummy = "../assets/images/dummy.png";
const dummyIcon = "../assets/images/dummy-image.png";
const delIcon = "../assets/images/delete-icon-white.svg";
const refIcon = "../assets/images/refresh-icon.svg";
const addBgIcon = "../assets/images/addicon-withbg.svg";
const removeBgIcon = "../assets/images/removeicon-withbg.svg";
const TableSearch = "../assets/images/table-search.svg";
const userIcon = "../assets/images/reviewer.png";
const badgeIcon = "../assets/images/badge.png";
const copyIcon = "../assets/images/copyIcon.svg";
const Archived = "../assets/images/archive.svg";
const StarActive = "../assets/images/fill-star.svg";
const StarBlank = "../assets/images/blank-star.svg";
const QRFrame = "../assets/images/qr-frame.png";
const Activate = "../assets/images/activate.svg";
const CircleIcon = "../assets/images/add-circle-fill.svg";
const CrossIcon = "../assets/images/cross-icon.svg";
const CircleLogo = "../assets/images/circleLogo.svg";
const DatabisLogo = "../assets/images/databis_logo.png";
const CollectIcon = "../assets/images/Collect.svg";
const MessageIcon = "../assets/images/Message.svg";
const StarsIcons = "../assets/images/Stars.svg";
const check = "../assets/images/checkfill.svg";
const MyAccountIcon = "../assets/images/myAccount.svg";
const DeleteCircle = "../assets/images/DeleteCircle.svg";
const MySubscriptionIcon = "../assets/images/subscription.svg";
const CartIcon = "../assets/images/cartIcon.svg";
const BasicSubIcon = "../assets/images/basic-subscription-icon.svg";
const PremiumSubIcon = "../assets/images/premium-subscription-icon.svg";
const ComingSoon = "../assets/images/comingSoon.svg";
const Help = "../assets/images/help.svg";
const PrivacyChoiceIcon = "../assets/images/privacy-choices.svg";
const TextFileIcon = "../assets/images/fileText.svg";
const NotFoundImage = "../assets/images/not-found-image.svg";
const PanelRightClose = "../assets/images/panel-right-close.svg";
const PanelRightOpen = "../assets/images/panel-right-open.svg";

const socialFacebookLogo = "../assets/images/facebook.svg";
const socialInstagramLogo = "../assets/images/instagram.svg";
const socialLinkedinLogo = "../assets/images/linkedin.svg";
const socialTwitterLogo = "../assets/images/twitter.svg";
const socialThreadsLogo = "../assets/images/threads.svg";
const socialTiktokLogo = "../assets/images/tiktok.svg";

// Analytics dashboard brand icons
const IconGraphDataBars = "../assets/images/databis/40-graph-data-bars.svg";
const IconGraphLine = "../assets/images/databis/26-graph-line.svg";
const IconChatHeart = "../assets/images/databis/10-chat-sq-heart.svg";
const IconChat = "../assets/images/databis/67-chat.svg";
const IconPeopleGroup = "../assets/images/databis/65-people-group.svg";
const IconPersonCheck = "../assets/images/databis/74-person-check.svg";
const IconPersonSync = "../assets/images/databis/59-person-sync.svg";
const IconBoxCheckmark = "../assets/images/databis/39-box-checkmark-filled.svg";
const IconQrCode = "../assets/images/databis/46-qr-code.svg";
const IconDocumentLines = "../assets/images/databis/30-document-lines.svg";
const IconSprout = "../assets/images/databis/51-sprout.svg";
const IconStar = "../assets/images/databis/07-star.svg";
const IconTrophy = "../assets/images/databis/19-trophy.svg";

export const IMAGES = {
  Help,
  Loader,
  Logo,
  Tick,
  Avtar,
  Notification,
  ComingSoon,
  NotFoundImage,

  SliderImage1,
  SliderImage2,
  SliderImage3,
  iconCalendar,
  AddCircle,
  editIcon,
  profilePlaceholder,
  whiteEditIcon,
  walletImage,
  Analytics,
  Batch,
  Strains,
  Employee,
  Reward,
  Api,
  Qr,
  Announcements,
  MenuUser,
  Logout,
  Company,
  infoIcon,
  cancelIcon,
  Support,
  deleteIcon,
  FilterIcon,
  FilterDate,
  FilterAccordion,
  TableAction,
  AddIcon,
  Verification,
  AccessDenied,
  ConnectionLost,
  Importicon,
  Uploadicon,
  Refreshicon,
  Refresh,
  NoData,
  CloudIcon,
  PreviewImage,
  ExcelIcon,
  COAPassedIcon,
  COAFailedIcon,
  upload,
  dummy,
  NoDataIcon,
  dummyIcon,
  delIcon,
  refIcon,
  addBgIcon,
  removeBgIcon,
  TableSearch,
  userIcon,
  badgeIcon,
  copyIcon,
  Archived,
  StarActive,
  StarBlank,
  QRFrame,
  Activate,
  CircleIcon,
  CrossIcon,
  CircleLogo,
  DatabisLogo,
  PanelRightClose,
  PanelRightOpen,
  CollectIcon,
  MessageIcon,
  StarsIcons,
  check,
  CartIcon,
  DeleteCircle,
  MyAccountIcon,
  MySubscriptionIcon,
  BasicSubIcon,
  PremiumSubIcon,
  PrivacyChoiceIcon,
  TextFileIcon,
  socialFacebookLogo,
  socialInstagramLogo,
  socialLinkedinLogo,
  socialTwitterLogo,
  socialThreadsLogo,
  socialTiktokLogo,
  // Analytics dashboard brand icons
  IconGraphDataBars,
  IconGraphLine,
  IconChatHeart,
  IconChat,
  IconPeopleGroup,
  IconPersonCheck,
  IconPersonSync,
  IconBoxCheckmark,
  IconQrCode,
  IconDocumentLines,
  IconSprout,
  IconStar,
  IconTrophy,
};
